
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormPhotoUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { GENDERS } from '../../../shared/constants';

export const AthleteNewForm = ({ initData, onDataChanged, clubData, traininggroupData }) => {
  const [newAthleteData, setNewAthleteData] = useState({ ...initData });

  useEffect(() => {
    initData.status = "aktiv";
    setNewAthleteData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newAthleteData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewAthleteData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
        <FormItem>
          <FormPhotoUploader />
        </FormItem>
      </GroupItem>

      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem>
          <FormTextbox
            label='Vorname'
            value={newAthleteData.surname}
            isEditing={false}
            onValueChange={updateField('surname')}
          />
        </FormItem>
        <FormItem>
          <FormTextbox
            label='Nachname'
            value={newAthleteData.lastname}
            isEditing={false}
            onValueChange={updateField('lastname')}
          />
        </FormItem>
        <FormItem>
          <FormDateBox
            label='Geburtsdatum'
            value={newAthleteData.dateofbirth}
            isEditing={false}
            onValueChange={updateField('dateofbirth')}
          />
        </FormItem>
        <FormItem>
          <FormSelectBox
            label='Geschlecht'
            value={newAthleteData.gender}
            isEditing={false}
            dataSource={GENDERS}
            valueExpr={'id'}
            displayExpr={'text'}
            onValueChange={updateField('gender')}
          />
        </FormItem>
        <FormItem>
          <FormSelectBox
            label='Trainingsgruppe'
            width='100%'
            value={newAthleteData.traininggroupId}
           
            dataSource={traininggroupData}
            displayExpr='groupname'
            valueExpr='traininggroupId'
            showClearButton={true}
            onValueChange={updateField('traininggroupId')}
          />
        </FormItem>
        <FormItem>
          <FormSelectBox
            label='Verein'
            width='100%'
            value={newAthleteData.clubId}
            dataSource={clubData}
            displayExpr='clubname'
            valueExpr='clubId'
            showClearButton={true}
            onValueChange={updateField('clubId')}
          />
        </FormItem>
        <FormItem>
          <FormTextbox
            label='DSV-ID'
            value={newAthleteData.dsvId}
            isEditing={false}
            onValueChange={updateField('dsvId')}
          />
        </FormItem>
        <FormItem>
          <FormDateBox
            label='Eintrittsdatum'
            value={newAthleteData.entrydate}
            isEditing={false}
            onValueChange={updateField('entrydate')}
          />
        </FormItem>
      </GroupItem>


    </Form>
  );
};
